
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 360 216","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M0 144.003h360.002v72H0z","fill":"#fc0"}}),_c('path',{attrs:{"d":"M0 72h360.002v72.001H0z","fill":"red"}}),_c('path',{attrs:{"d":"M0 0h360.002v72H0z"}})])])
          )
        }
      }
    